import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Input,
    OnInit,
    QueryList,
    ViewChildren,
} from '@angular/core';
import {
    AbstractControl,
    ValidatorFn,
    Validators,
} from '@angular/forms';

import { NDDFormErrorService } from '../ndd-ng-form-error/shared/ndd-ng-form-error.service';
import { NDDFormsBuilderService } from '../shared/ndd-ng-forms-builder.service';
import { NDDFormsBaseComponent } from '../shared/ndd-ng-forms.base-component';

/** Componente de grupo de botão de radio */
@Component({
    selector: 'ndd-ng-form-radio-btn-group',
    template: require('./ndd-ng-form-radio-btn-group.component.html'),
})
export class NDDFormRadioBtnGroupComponent extends NDDFormsBaseComponent implements OnInit, AfterViewInit {
    /** Define a descrição do grupo do radio btn */
    @Input() public controlDescription?: string;

    /** Define as características visuais do radio btn*/
    @Input() public controlBtnLarge: boolean;

    /** Define a largura máxima do radio btn*/
    @Input() public controlMaxWidthBtn: Number;

    /** Define a largura máxima do grupo radio btn*/
    @Input() public controlMaxWidth: Number;

    @ViewChildren('contentRef') private contentRef: QueryList<ElementRef>;

    constructor(formErrorService: NDDFormErrorService, cdr: ChangeDetectorRef) {
        super(formErrorService, cdr);
    }

    public ngOnInit(): void {
        this.addControl();
        super.addValidators();
    }

    public ngAfterViewInit(): void {
        if (this.controlMaxWidth) {
            this.contentRef.first.nativeElement.style.maxWidth = this.controlMaxWidth;
        }
    }

    public getControl(): AbstractControl {
        return this.control;
    }

    protected addControl(): void {
        if (!this.controlForm) { throw new Error('É necessário definir `controlForm` para elementos de formulário.'); }
        if (!this.controlKey) { throw new Error('É necessário definir `controlKey` para elementos de formulário.'); }

        this.control = NDDFormsBuilderService.addControl(this.controlForm, this);

        if (this.controlRequired) {
            this.cacheValidator(Validators.required);
        }

        if (this.controlCustomValidators && this.controlCustomValidators.length) {
            this.controlCustomValidators.forEach((validator: ValidatorFn) => {
                this.cacheValidator(validator);
            });
        }
    }
}
